module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step2-cc5ad85c1ced95b79af5ccc98614e0d8.jpg";